/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { createStore, createApi, createEffect, sample } from 'effector';

import { delayedSignalsApi } from './delayedSignal';
import { positionsApi } from './positions';
import { newMultipleMarketSignal, newMarketSignal, newDelayedSignal, changeSignal, canSendSignal } from '../api';
import { ApiDataResponse } from '../api/types/response';
import { DelayedSignal } from '../types/delayedSignal';
import { Position } from '../types/position';
import { Nullable } from '../utils/types';

type TSignals$State = {
  delay: Nullable<number>;
};

const initialState: TSignals$State = {
  delay: null,
};

export const Signals$ = createStore(initialState);

const { setDelay } = createApi(Signals$, {
  // @ts-ignore
  setDelay: (state, { result }) => {
    if (result?.success) {
      return { delay: result.result.secondsLeft };
    }
    return state;
  },
});

export const signalsApi = {
  newMarket: createEffect<Partial<Position>, ApiDataResponse<unknown>, {}>().use(newMarketSignal),
  newDelayed: createEffect<Partial<DelayedSignal>, ApiDataResponse<unknown>, {}>().use(newDelayedSignal),
  newMultipleMarketSignal: createEffect<Partial<Position>[], {}, {}>().use(newMultipleMarketSignal),
  changeSignal: createEffect<Partial<Position>, ApiDataResponse<unknown>, {}>().use(changeSignal),
  checkSignal: createEffect<string, {}, {}>(canSendSignal),
};

sample({
  clock: [signalsApi.newMarket.done, signalsApi.newDelayed.done],
  filter: ({ result, params }) =>
    result?.success && !!params && 'execQuotation' in params && Boolean(params.execQuotation),
  fn: ({ result }) => result.result,
  target: delayedSignalsApi.add,
});

sample({
  clock: [signalsApi.newMarket.done, signalsApi.newDelayed.done],
  filter: ({ result, params }) => result?.success && (!params || !('execQuotation' in params) || !params.execQuotation),
  fn: ({ result }) => result.result,
  target: positionsApi.add,
});

sample({
  clock: signalsApi.changeSignal.done,
  filter: ({ result }) => result?.success,
  fn: ({ result }) => result.result,
  target: positionsApi.update,
});

sample({
  clock: signalsApi.checkSignal.done,
  target: setDelay,
});
